import React, { useEffect, useState, useCallback } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { GetAllPatientList } from './config/PatientApi';
import { handleResetPatientFilter } from './config/PatientSlice';
import PatientFilter from './components/PatientFilter';
import { FiDownloadCloud } from 'react-icons/fi';
import PatientTableData from './components/PatientTableData';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Patient = () => {
    const dispatch = useDispatch();
    const { patientFilters, patientList } = useSelector((state) => state.patient);
    const { allPermissionType } = useSelector((state) => state.role);
    const patientSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
        (item) => item?.rolemngmttyp_name === "Patient" // Assuming "Patient" is the correct name
    );

    const {
        control,
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        formState: { errors }
    } = useForm({
        defaultValues: {
            branch_id: null,
            patient_name: "",
            patient_national_id: "",
            patient_mobile_no: "",
            patient_email: "",
            patient_mrn: ''
        }
    });


    console.log({ patientList })

    const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));


    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);

    const fetchPatients = (body = {}) => {
        dispatch(GetAllPatientList(body)).unwrap().then((data) => {
            if (data?.success) {
                setTotalRows(data?.total_rows || 0);
            }
        }).catch(() => {
            toast.error("Failed to fetch patients");
        });
    };

    const handlePageChange = useCallback((newPage) => {
        setPage(newPage);
    }, []);

    const handlePerRowsChange = useCallback((newPerPage) => {
        setRowsPerPage(newPerPage);
        setPage(0);
    }, []);

    const requestBody = (customPage = page, customLimit = rowsPerPage) => ({
        branch_id:
            patientFilters?.branch_id?.branch_id ||
            selectedBranch?.branch_id ||
            selectedBranch?.value ||
            "",
        pat_name: patientFilters?.patient_name || "",
        pat_natid: patientFilters?.patient_national_id || "",
        pat_mobileno: patientFilters?.patient_mobile_no || "",
        pat_emailid: patientFilters?.patient_email || "",
        pat_mrn: patientFilters?.patient_mrn || "",
        start_point: customPage,
        limit: customLimit,
        // Add other filter fields as needed
    });

    useEffect(() => {
        const body = requestBody();
        fetchPatients(body);
    }, [page, rowsPerPage]);

    const handleReset = () => {
        reset();
        dispatch(handleResetPatientFilter());
        setPage(0);
        const resetBody = {
            branch_id:
                patientFilters?.branch_id?.branch_id ||
                selectedBranch?.branch_id ||
                selectedBranch?.value ||
                "",
            pat_name: "",
            pat_natid: "",
            pat_mobileno: "",
            pat_emailid: "",
            pat_mrn: "",
            start_point: 0,
            limit: 10,

        }
        fetchPatients(resetBody);
    };

    const onSubmit = () => {
        setPage(0);
        const body = requestBody(0, rowsPerPage);
        fetchPatients(body);
    };

    const handleDownloadExcel = async () => {
        try {
            const body = {
                ...requestBody(0, totalRows),
                limit: totalRows
            };

            const response = await dispatch(GetAllPatientList(body)).unwrap();
            const data = response?.data || [];

            const headers = [
                "#",
                "Branch",
                "MRN",
                "Name",
                "Mobile No.",
                "Email",
                "National ID",
                "Nationality",
                "Insurance Name",
                "Insurance No.",
                "Insurance Class Name",
                "Insurance Network",
            ];

            const rows = data.map((row, index) => [
                index + 1,
                row?.branch || '',
                row?.patient_mrn || '',
                `${row?.patient_firstname || ''} ${row?.patient_fathername || ''} ${row?.patient_familyname || ''}`,
                row?.patient_mobilenumber || '',
                row?.patient_emailid || '',
                row?.patient_nationalid || '',
                row?.nationality || '',
                row?.insurance?.patpolcy_name || '',
                row?.insurance?.patpolcy_number || '',
                row?.insurance?.patins_clsnme || '',
                row?.insurance?.patins_network || '',
            ]);

            const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Patients");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            saveAs(
                blob,
                `Patient_List_${moment().format("DD-MM-YYYY_hh-mm-ss_A")}.xlsx`
            );

        } catch (error) {
            console.error("Excel download failed:", error);
        }
    };

    return (
        <>
            {Number(patientSetting?.list) === 1 ? (
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <FalconComponentCard className="shadow-md">
                        <FalconComponentCard.Header className="d-flex fixed-header justify-content-between align-items-center">
                            <Col xs="auto m-0">
                                <h5 className="text-primary mb-0 fs-10">Patient List</h5>
                            </Col>
                            <Col xs="auto" className="d-flex gap-2">
                                <Button size="sm" variant="outline-danger" onClick={handleReset}>
                                    Reset
                                </Button>
                                <Button type="submit" size="sm" variant="success">
                                    Filter
                                </Button>
                                {Number(patientSetting?.export) === 1 && (
                                    <Button size="sm" variant="warning" onClick={handleDownloadExcel}>
                                        <FiDownloadCloud size={16} />
                                        Excel
                                    </Button>
                                )}
                            </Col>
                        </FalconComponentCard.Header>
                        <FalconComponentCard.Body style={{ marginTop: "40px" }}>
                            <PatientFilter
                                control={control}
                                setValue={setValue}
                                clearErrors={clearErrors}
                                errors={errors}
                            />
                            <PatientTableData
                                data={patientList}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                totalRows={totalRows}
                                handlePageChange={handlePageChange}
                                handlePerRowsChange={handlePerRowsChange}
                                setting={patientSetting}
                            />
                        </FalconComponentCard.Body>
                    </FalconComponentCard>
                </Form>
            ) : (
                <div className="py-6 text-center border rounded-3mb-3">
                    <h5 className="text-danger">Permission Denied</h5>
                    <p className="text-muted fs-11">
                        You do not have permission to view Patient.
                    </p>
                </div>
            )}
        </>
    );
};

export default Patient;
